import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxFullCalendarModule } from 'ngx-fullcalendar';
import { ReplaceUnderscorePipe,TokenGuard } from '../services';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModule } from './material.module';
import { MyDatePickerModule } from 'mydatepicker';
// Dashboard Component Declare here
import {
   AccountsComponent,TaxinvoiceComponent,ViewprofileComponent, DashboardComponent, AccountBalanceComponent, BookingComponent, BookingviewComponent, BookingfailListComponent, EnquiryComponent, EnquirySeenComponent, PaymentComponent, BookSummeryComponent, 
    
//    DealhomeComponent
} from '../dashboard';
import { DropDownButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { DropDownListAllModule, MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { MaskedTextBoxModule, UploaderAllModule } from '@syncfusion/ej2-angular-inputs'
import { ToolbarAllModule, ContextMenuAllModule } from '@syncfusion/ej2-angular-navigations';
import { ButtonAllModule, CheckBoxAllModule, SwitchAllModule } from '@syncfusion/ej2-angular-buttons';
import { DatePickerAllModule, TimePickerAllModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxAllModule, TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { ScheduleAllModule, RecurrenceEditorAllModule } from '@syncfusion/ej2-angular-schedule';
import { OrderModule } from 'ngx-order-pipe';
import { DealhomeComponent } from '../dashboard/dealhome/dealhome.component';
import { SearchResultComponent } from '../dashboard/search-result/search-result.component';

export const RouteConfiqFileRoutes: Routes = [
    { path: 'dashboard1', component: DashboardComponent },
    { path: 'dashboard1/dashboard/:id', component: DashboardComponent},
    { path: 'dashboard1/add', component:DashboardComponent },
    { path: 'accounts', component:AccountsComponent},
    { path: 'bookings', component:BookingComponent},
    { path: 'bookings/bookingview/:type', component:BookingviewComponent},
    { path: 'viewprofile', component:ViewprofileComponent},
    { path: 'taxinvoice', component:TaxinvoiceComponent},
    { path: 'account-balance', component:AccountBalanceComponent},
    { path: 'bookingfail-list', component:BookingfailListComponent},
    { path: 'dealhome', component:DealhomeComponent},
    { path: 'search-result',component:SearchResultComponent},
    { path: 'enquiry-form',component:EnquiryComponent},
    { path: 'enquiry-seen',component:EnquirySeenComponent},
    { path: 'payment',component:PaymentComponent},
    { path: 'book-summery',component:BookSummeryComponent},
      
];
const BASE_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxFullCalendarModule,
    NgxPaginationModule,MyDatePickerModule,
    MaterialModule
]; 
const CalendarModule =[
    ScheduleAllModule, RecurrenceEditorAllModule,   NumericTextBoxAllModule, TextBoxAllModule, DatePickerAllModule, TimePickerAllModule, DateTimePickerAllModule, CheckBoxAllModule,   ToolbarAllModule, DropDownListAllModule, ContextMenuAllModule, MaskedTextBoxModule, UploaderAllModule, MultiSelectAllModule,   TreeViewModule, ButtonAllModule, DropDownButtonAllModule, SwitchAllModule,
]
const COMPONENTS = [
// Dashboard Component Declare here
    DashboardComponent,AccountsComponent,AccountBalanceComponent,ViewprofileComponent,TaxinvoiceComponent, BookingComponent,BookingviewComponent,BookingfailListComponent,DealhomeComponent,SearchResultComponent,
    // DealhomeComponent
    EnquiryComponent,EnquirySeenComponent,PaymentComponent,BookSummeryComponent

];
const COMMON_COMPONENTS = [
    ReplaceUnderscorePipe
];
@NgModule({
    imports: [...BASE_MODULES,...CalendarModule,RouterModule.forChild(RouteConfiqFileRoutes),OrderModule],
    declarations: [...COMPONENTS,...COMMON_COMPONENTS]
})
export class RouteConfiqFileModule {}

